import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Loader from "react-loader-spinner";
import { ShieldCheck, Lock } from "lucide-react";
import httpClient from "../../custom-hooks/httpClient";
import Modal from "../Modal";

const pinInputStyle = {
  height: 52,
  fontFamily: "Verdana, sans-serif",
  fontSize: "1.25rem",
  letterSpacing: "0.6em",
  paddingLeft: "0.6em",
  color: "#0F5C30",
};

const labelStyle = { fontSize: "0.75rem" };

function TransactionPin({ onClose }) {
  const [areFieldsSet, setAreFieldsSet] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [transactionPin, setTransactionPin] = useState({
    transaction_pin: "",
    confirm_transaction_pin: "",
  });

  const handleChange = (e) => {
    setTransactionPin({ ...transactionPin, [e.target.id]: e.target.value });
  };

  const userToken = localStorage.getItem("tk");

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const id = localStorage.getItem("id");

    if (
      transactionPin.transaction_pin !== transactionPin.confirm_transaction_pin
    ) {
      toast.error("Transaction PIN mismatch!");
      return;
    }

    httpClient
      .post(`/users/${id}/create-transaction-pin`, {
        transactionPin,
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      })
      .then(({ status }) => {
        setIsSubmitting(false);
        if (status === 200) {
          toast.success("Transaction PIN Created!", {
            autoClose: 1500, // Time for the toast message to remain visible
          });
          // Reload the current page after a delay of 3 seconds.
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        }
      })
      .catch((err) => {
        setIsSubmitting(false);
        toast.error(err.response.data.message);
      });
    onClose();
  };

  useEffect(() => {
    const isPinValid = transactionPin.transaction_pin.length === 6 && transactionPin.confirm_transaction_pin.length === 6;
    const areFieldsValid = Object.values(transactionPin).every((value) => value !== "") && isPinValid;
    setAreFieldsSet(areFieldsValid);
  }, [transactionPin]);

  return (
    <>
      <section>
        <Modal
          showModal={true}
          setShowModal={onClose}
          clickOut={true}
          noPadding
          maxWidth={440}
        >
          <div
            className="modal-header border-0 p-4 d-flex align-items-center justify-content-center gap-2 position-relative"
            style={{ background: "#0F5C30" }}
          >
            <ShieldCheck size={18} color="#fff" />
            <h2
              className="mb-0"
              id="modalExampleTitle"
              style={{ fontSize: "0.95rem", fontWeight: 600, color: "#fff" }}
            >
              Transaction PIN Setup
            </h2>
            <button
              type="button"
              className="btn-close btn-close-white position-absolute"
              style={{
                right: 20,
                top: "50%",
                transform: "translateY(-50%)",
                margin: 0,
              }}
              aria-label="Close"
              onClick={onClose}
            />
          </div>

          <div className="modal-body px-5 pt-5 pb-5 text-center">
            <div
              className="d-flex align-items-center justify-content-center rounded-circle mx-auto mb-3"
              style={{ width: 56, height: 56, background: "#E8F5E9" }}
            >
              <Lock size={24} color="#0F5C30" />
            </div>

            <p
              className="mb-1"
              style={{ fontSize: "1rem", fontWeight: 600, color: "#0d1b12" }}
            >
              Create your transaction PIN
            </p>
            <p
              className="text-muted mb-5"
              style={{ fontSize: "0.82rem", lineHeight: 1.6 }}
            >
              Set a 6-digit PIN for approving transactions. Use a different PIN
              from your login PIN.
            </p>

            <form onSubmit={handleSubmit} className="text-start">
              <label
                htmlFor="transaction_pin"
                className="form-label text-muted mb-1"
                style={labelStyle}
              >
                PIN
              </label>
              <input
                type="password"
                name="transaction_pin"
                id="transaction_pin"
                className="form-control text-center mb-3"
                placeholder="••••••"
                title="Numbers only (e.g. 123456)"
                maxLength="6"
                pattern="[0-9]{6}"
                required
                onChange={handleChange}
                style={pinInputStyle}
              />

              <label
                htmlFor="confirm_transaction_pin"
                className="form-label text-muted mb-1"
                style={labelStyle}
              >
                Confirm PIN
              </label>
              <input
                type="password"
                name="confirm_transaction_pin"
                id="confirm_transaction_pin"
                className="form-control text-center"
                placeholder="••••••"
                title="Numbers only (e.g. 123456)"
                maxLength="6"
                pattern="[0-9]{6}"
                required
                onChange={handleChange}
                style={pinInputStyle}
              />

              {areFieldsSet ? (
                isSubmitting ? (
                  <button className="btn w-100 btn-primary mt-5 lift">
                    <Loader type="Oval" color="#fff" width={20} height={20} />
                  </button>
                ) : (
                  <button
                    className="btn w-100 btn-primary mt-5 lift"
                    type="submit"
                  >
                    Submit
                  </button>
                )
              ) : (
                <button
                  className="btn w-100 btn-primary mt-5 lift"
                  type="button"
                  disabled
                >
                  Submit
                </button>
              )}
            </form>
          </div>
        </Modal>
      </section>
    </>
  );
}

export default TransactionPin;
